import Search from 'flarum/forum/components/Search';
import UserSearchSource from './UserSearchSource';
import ItemList from 'flarum/common/utils/ItemList';
import classList from 'flarum/common/utils/classList';
import extractText from 'flarum/common/utils/extractText';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import recipientLabel from './recipientLabel';
import Stream from 'flarum/common/utils/Stream';
import app from 'flarum/forum/app';
export default class RecipientSearch extends Search {
  oninit(vnode) {
    this.value = Stream();
    super.oninit(vnode);
  }
  updateMaxHeight() {
    // stub
  }
  view(vnode) {
    if (this.value() == null) {
      this.value('');
    }
    const loading = this.value() && this.value().length >= 3;
    this.sources ??= this.sourceItems().toArray();
    return m("div", {
      className: "AddRecipientModal-body"
    }, app.cache.conversationsRecipient === null ? m("div", {
      className: "AddRecipientModal-form-input"
    }, m("input", {
      className: classList('RecipientsInput FormControl', {
        open: !!this.value(),
        focused: !!this.value(),
        active: !!this.value(),
        loading: !!this.loadingSources
      }),
      config: function (element) {
        element.focus();
      },
      type: "search",
      placeholder: extractText(app.translator.trans('neoncube-private-messages.forum.modal.search_recipients')),
      value: this.value(),
      oninput: event => {
        this.value(event.target.value);
        clearTimeout(this.typingTimer);
        this.doSearch = false;
        this.typingTimer = setTimeout(() => {
          this.doSearch = true;
          m.redraw();
        }, 300);
      },
      onfocus: () => this.hasFocus = true,
      onblur: () => this.hasFocus = false
    }), m("ul", {
      className: classList('Dropdown-menu Search-results fade', {
        in: !!loading
      })
    }, !this.doSearch ? m(LoadingIndicator, {
      size: "tiny",
      className: "Button Button--icon Button--link"
    }) : this.sources.map(source => source.view(this.value())), m("li", null, m("span", null, app.translator.trans('neoncube-private-messages.forum.modal.more_users'))))) : m("div", {
      className: "RecipientsInput-selected RecipientsLabel"
    }, recipientLabel(app.cache.conversationsRecipient, {
      onclick: () => {
        this.removeRecipient(app.cache.conversationsRecipient);
      }
    })));
  }

  /**
   * Build an item list of SearchSources.
   *
   * @return {ItemList}
   */
  sourceItems() {
    const items = new ItemList();
    items.add('users', new UserSearchSource(id => this.addRecipient(id)));
    return items;
  }

  /**
   * Clear the search input and the current controller's active search.
   */
  selectResult() {
    const id = this.getItem(this.index).data('index');
    if (id) this.addRecipient(id);
  }
  onremove(vnode) {
    clearTimeout(this.typingTimer);
    super.onremove(vnode);
  }
  clear() {
    this.value('');
    m.redraw();
  }

  /**
   * Adds a recipient.
   *
   * @param value
   */
  addRecipient(value) {
    app.cache.conversationsRecipient = app.store.getById('users', value);
    this.clear();
  }

  /**
   * Removes a recipient.
   *
   * @param recipient
   */
  removeRecipient(recipient) {
    app.cache.conversationsRecipient = null;
    m.redraw();
  }

  /**
   * Loads a recipient from the global store.
   *
   * @param store
   * @param id
   * @returns {Model}
   */
  findRecipient(store, id) {
    return app.store.getById(store, id);
  }
}
flarum.reg.add('flatrate-private-messages-bridge', 'forum/components/RecipientSearch', RecipientSearch);